import React from "react";
import { Tag } from "antd";
import { $t } from "~/i18n.js";

export const BaseGroups = ["zweefvlieger", "gastvlieger", "niet_vliegend"];
export const Flyinggroups = ["dbo", "solist", "brevet", "basic_instructor", "instructeur"];
const topGroups = BaseGroups.concat(Flyinggroups);

export const SortAllGroupKeys = (group_lookup) => {
  // return sorted list of groups, with on top the base groups
  // Added to redux: flights.all_group_keys
  if (!group_lookup) return [];
  const all_group_keys = Object.keys(group_lookup);
  
  // Sort keys based on group_lookup values
  all_group_keys.sort((a, b) => {
    if (group_lookup[a] < group_lookup[b]) return -1;
    if (group_lookup[a] > group_lookup[b]) return 1;
    return 0;
  });

  return topGroups.concat(
    all_group_keys.filter((group) => !topGroups.includes(group))
  );
};

export const AllGroupsListForSelect = (keys, name_lookup) => {
  // Added to redux: flights.all_group_list
  return topGroups
    .concat(keys.filter((group) => !topGroups.includes(group)))
    .map((key) => ({
      value: key,
      label: name_lookup[key],
    }));
};

export const SortedGroupList = (groups) => {
  // Return sorted list of groups, on top the base groups and after the remainder
  if (!groups) return [];
  return groups.map((g) => {
    
    g.is_base = BaseGroups.indexOf(g.key);
    g.is_vliegend = Flyinggroups.indexOf(g.key);
    
    if (g.is_base >= 0) {
      g.index = "0_" + g.is_base;
    } else if (g.is_vliegend >= 0) {
      g.index = "1_" + g.is_vliegend;
    } else {
      g.index = '2_' + g.name.toLowerCase();
    }
    
    return g
  }).sort((a, b) => a.index.localeCompare(b.index))
};

export const SortedGroupKeys = (group_keys) => {
  // sort keys based on the logic that the base groups come first
  if (!group_keys) return [];
  const base = group_keys.filter((k) => BaseGroups.includes(k));
  const flying = group_keys.filter((k) => Flyinggroups.includes(k));
  const others = group_keys.filter((k) => !BaseGroups.includes(k) && !Flyinggroups.includes(k));
  return [...base, ...flying, ...others];
}

export const GroupTag = ({ group_key }) => {
  if (BaseGroups.includes(group_key)) {
    return <Tag color="green">{$t("Kern")}</Tag>;
  }
  if (Flyinggroups.includes(group_key)) {
    return <Tag color="gold">{$t("Vliegend")}</Tag>;
  }
  return null;
};

export const CheckIfUserInBaseGroup = (user) => {
  if (!user) return false;
  if (user.has_temporary_password) return true;
  return user.group_keys?.some((group) => BaseGroups.includes(group));
};
